import request from '@/utils/request'; //绑定三方列表

export function bindThreeList(data) {
  return request({
    url: '/pay/bind_login',
    method: 'get',
    params: data
  });
}